import { useContext } from 'react';
import { ReferralCodeContext } from '../contexts/ReferralCodeContext';
import { buildShopUsDiscountUrl } from '../utils/shopUsReferral';

export function useShopUsHref(href: string | undefined): string | undefined {
    const { code } = useContext(ReferralCodeContext);
    return href && code ? buildShopUsDiscountUrl(href, code) : href;
}
